module.exports = __webpack_public_path__ + "img/questionParagraph.298bea4d.svg";